import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { useLocation } from "react-router-dom";

// CSS imports
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Custom styles
const customStyles = `
.swiper-button-next,
.swiper-button-prev {
  color: white;
  background-color: transparent;
  padding: 30px;
  border-radius: 50%;
  width: 15px;
  height: 15px;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 20px;
}

.swiper-button-next:hover,
.swiper-button-prev:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.swiper-button-disabled {
  opacity: 0.35;
  cursor: auto;
  pointer-events: none;
}

.swiper-pagination-bullet {
  background-color: white;
}

.swiper-pagination-bullet-active {
  background-color: white;
}

/* Lazy loading spinner styles */
.swiper-lazy-preloader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@keyframes spin {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}
`;

interface CarouselProps {
  images: Record<string, string[]>;
  className?: string;
}

const Carousel: React.FC<CarouselProps> = ({ images, className }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const currentImages =
    currentPath === "/kemper"
      ? images["kemper"]
      : currentPath === "/tonex"
      ? images["tonex"]
      : currentPath === "/nam"
      ? images["nam"]
      : currentPath === "/plugins"
      ? images["plugin"]
      : images["home"] || [];

  return (
    <div className={`relative overflow-hidden ${className || ""}`}>
      <style>{customStyles}</style>

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={50}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
        className="w-full"
      >
        {currentImages.map((image, index) => (
          <SwiperSlide key={`slide-${index}`}>
            <div className="relative w-full h-full">
              <img
                src={image}
                loading="lazy"
                className="w-full aspect-video max-h-[400px] object-cover"
                alt={`Carousel ${index + 1}`}
              />
              <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Carousel;
